var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"big-card-button",attrs:{"link":"","to":_vm.to,"target":_vm.target}},[_c('v-icon',{staticClass:"big-card-icon"},[_vm._v(" "+_vm._s(this.icon)+" ")]),_c('div',{staticClass:"big-card-title"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }